/* Highest Tendencies theme */
(function () {
  'use strict';

  var HT = window.HT || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', all: '/collections/all' } };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var reduced = function () { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var canHover = function () { return window.matchMedia && matchMedia('(hover: hover)').matches; };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var fmt = format || HT.moneyFormat || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var withDelims = function (n, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    };
    var value = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2);
    }
    return m ? fmt.replace(m[0], value) : value;
  }
  var rate = function () { return (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1; };
  var sized = function (url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };

  /* ---------- page lock (menu / cart) ---------- */
  function syncLock() {
    var open = document.body.classList.contains('menu-open') || ($('#CartDrawer') && $('#CartDrawer').classList.contains('on'));
    document.body.classList.toggle('lock', !!open);
  }

  /* ---------- announcement rotator ---------- */
  function initAnnouncement(scope) {
    $$('[data-rotator]', scope).forEach(function (el) {
      clearInterval(el._t);
      var msgs = $$('.ann-msg', el);
      if (msgs.length < 2) return;
      var i = 0;
      el._t = setInterval(function () {
        msgs[i].classList.remove('on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('on');
      }, parseInt(el.dataset.interval, 10) || 4000);
    });
  }

  /* ---------- menu drawer ---------- */
  function openMenu() {
    document.body.classList.add('menu-open');
    var m = $('#MenuDrawer'); if (m) m.setAttribute('aria-hidden', 'false');
    $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    syncLock();
  }
  function closeMenu() {
    document.body.classList.remove('menu-open');
    var m = $('#MenuDrawer'); if (m) m.setAttribute('aria-hidden', 'true');
    $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    syncLock();
  }

  /* ---------- cart ---------- */
  var Cart = {
    state: null,
    upsell: null,
    init: function () {
      try { this.state = JSON.parse($('#CartData').textContent); } catch (e) { this.state = null; }
      try { this.upsell = JSON.parse($('#UpsellData').textContent); } catch (e) { this.upsell = []; }
      this.render();
    },
    fetch: function () {
      var self = this;
      return fetch(HT.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.state = c; self.render(); return c; });
    },
    add: function (id, qty) {
      return this.addItems([{ id: id, quantity: qty || 1 }]);
    },
    addItems: function (items) {
      var self = this;
      return fetch(HT.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || 'Could not add to cart');
          return body;
        });
      }).then(function () {
        if (HT.cartType === 'page') { window.location.href = HT.routes.cart; return; }
        return self.fetch().then(function () { self.open(); });
      });
    },
    change: function (key, quantity) {
      var self = this, body = $('#CartBody');
      if (body) body.classList.add('dr-busy');
      return fetch(HT.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); })
        .then(function (c) { self.state = c; self.render(); })
        .catch(function () { return self.fetch(); })
        .then(function () { if (body) body.classList.remove('dr-busy'); });
    },
    open: function () {
      var d = $('#CartDrawer'); if (!d) return;
      closeMenu();
      d.classList.add('on'); d.setAttribute('aria-hidden', 'false');
      $('#CartScrim').classList.add('on');
      syncLock();
      setTimeout(function () { d.focus(); }, 50);
    },
    close: function () {
      var d = $('#CartDrawer'); if (!d) return;
      d.classList.remove('on'); d.setAttribute('aria-hidden', 'true');
      $('#CartScrim').classList.remove('on');
      syncLock();
    },
    partnerOf: function (title) {
      var info = pieceInfo(title);
      if (!info) return null;
      var list = this.upsell || [];
      for (var i = 0; i < list.length; i++) {
        var o = pieceInfo(list[i].title);
        if (o && list[i].available && o.color === info.color && o.type !== info.type) return list[i];
      }
      return null;
    },
    render: function () {
      var c = this.state;
      $$('[data-cart-count]').forEach(function (e) { e.textContent = c ? c.item_count : 0; });
      var goal = $('#CartGoal'), body = $('#CartBody'), foot = $('#CartFoot');
      if (!body || !c) return;
      if (!c.item_count) {
        goal.innerHTML = '';
        foot.innerHTML = '';
        body.innerHTML = '<div class="empty">Your cart is empty<a class="btn" href="' + esc(HT.routes.all) + '" data-cart-close>Shop all products</a></div>';
        return;
      }
      var total = c.total_price;
      // free shipping / reward progress
      var goalHTML = '';
      if (HT.freeShip && HT.freeShipAt > 0) {
        var ship = Math.round(HT.freeShipAt * 100 * rate());
        var tierAt = Math.round((HT.tierAt || 0) * 100 * rate());
        var msg, pct;
        if (total < ship) {
          msg = 'You\'re <b>' + formatMoney(ship - total) + '</b> away from free shipping';
          pct = total / ship;
        } else if (HT.tier && tierAt > ship && total < tierAt) {
          msg = 'Free shipping unlocked &middot; <b>' + formatMoney(tierAt - total) + '</b> away from ' + esc(HT.tierLabel);
          pct = total / tierAt;
        } else if (HT.tier && tierAt > ship) {
          msg = 'Free shipping + ' + esc(HT.tierLabel) + ' unlocked';
          pct = 1;
        } else {
          msg = 'Free shipping unlocked';
          pct = 1;
        }
        goalHTML = '<div class="goal"><p>' + msg + '</p><div class="goal-bar"><i style="width:' + Math.min(100, pct * 100).toFixed(1) + '%"></i></div></div>';
      }
      goal.innerHTML = goalHTML;

      var inCart = {};
      var lines = c.items.map(function (it) {
        inCart[it.handle] = true;
        var meta = it.product_has_only_default_variant ? '' : '<div class="line-meta">' + esc(it.variant_title) + '</div>';
        var disc = (it.line_level_discount_allocations || []).map(function (d) { return '<div class="line-meta">' + esc(d.discount_application.title) + ' (&minus;' + formatMoney(d.amount) + ')</div>'; }).join('');
        var price = it.original_line_price > it.final_line_price
          ? formatMoney(it.final_line_price) + ' <s>' + formatMoney(it.original_line_price) + '</s>'
          : formatMoney(it.final_line_price);
        return '<div class="line"><a href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sized(it.image, 240)) + '" alt="" loading="lazy" width="86" height="86">' : '') + '</a>' +
          '<div class="line-main"><div class="line-top"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a><span>' + price + '</span></div>' + meta + disc +
          '<div class="line-row"><span class="qty"><button type="button" data-qty="' + esc(it.key) + '" data-to="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button><span>' + it.quantity + '</span><button type="button" data-qty="' + esc(it.key) + '" data-to="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></span>' +
          '<button type="button" class="link" data-qty="' + esc(it.key) + '" data-to="0">Remove</button></div></div></div>';
      }).join('');

      // upsells: complete the set first, otherwise "you may also like"
      var up = '', self = this;
      if (HT.setUpsell) {
        var partner = null;
        c.items.some(function (it) { var p = self.partnerOf(it.product_title); if (p && !inCart[p.handle]) { partner = p; return true; } return false; });
        if (partner) up = '<div class="up"><div class="label">Complete the set</div>' + quickRow(partner) + '</div>';
      }
      if (!up && HT.upsell) {
        var more = (this.upsell || []).filter(function (p) { return p.available && !inCart[p.handle]; }).slice(0, 6);
        if (more.length) up = '<div class="up"><div class="label">You may also like</div><div class="minis">' + more.map(miniCard).join('') + '</div></div>';
      }
      body.innerHTML = lines + up;

      var discounts = (c.cart_level_discount_applications || []).map(function (d) {
        return '<div class="tot sub"><span>' + esc(d.title) + '</span><span>&minus;' + formatMoney(d.total_allocated_amount) + '</span></div>';
      }).join('');
      var shipNote = (HT.freeShip && HT.freeShipAt > 0 && total >= Math.round(HT.freeShipAt * 100 * rate())) ? 'Free shipping. Taxes calculated at checkout.' : 'Shipping and taxes calculated at checkout.';
      foot.innerHTML = discounts +
        '<div class="tot"><span>Subtotal</span><span>' + formatMoney(total) + '</span></div>' +
        '<p class="dr-note">' + shipNote + '</p>' +
        '<form action="' + esc(HT.routes.cart) + '" method="post"><button type="submit" name="checkout" class="btn">Checkout</button></form>';
    }
  };

  function pieceInfo(title) {
    var t = String(title || '').toLowerCase();
    var m = t.match(/'([^']+)'/);
    if (!m) return null;
    var type = /hoodie/.test(t) ? 'hoodie' : (/sweatpant|pants/.test(t) ? 'pants' : null);
    return type ? { color: m[1].trim(), type: type } : null;
  }
  function priceHTML(p) {
    return formatMoney(p.price) + (p.compare > p.price ? ' <s>' + formatMoney(p.compare) + '</s>' : '');
  }
  function chipsHTML(p) {
    return '<div class="chips">' + p.variants.map(function (v) {
      var label = v.title === 'Default Title' ? 'Add' : v.title.replace(/^small$/i, 'S').replace(/^medium$/i, 'M').replace(/^large$/i, 'L').replace(/^x-large$/i, 'XL');
      return '<button type="button" class="chip" data-add="' + v.id + '"' + (v.available ? '' : ' disabled') + ' aria-label="Add ' + esc(p.title) + ', ' + esc(v.title) + '">' + esc(label) + '</button>';
    }).join('') + '</div>';
  }
  function quickRow(p) {
    return '<div class="qa"><div class="qa-row"><a href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="62" height="62">' : '') + '</a>' +
      '<div class="qa-info"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a><span>' + priceHTML(p) + '</span></div>' +
      '<button type="button" class="qa-open" data-qa-open>Add</button></div>' + chipsHTML(p) + '</div>';
  }
  function miniCard(p) {
    return '<div class="mini"><a href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="132" height="132">' : '') + '</a>' +
      '<a class="mini-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="mini-price">' + priceHTML(p) + '</span>' +
      '<div class="qa"><button type="button" class="qa-open" data-qa-open>Add</button>' + chipsHTML(p) + '</div></div>';
  }

  /* ---------- shipping estimate ---------- */
  function parseShip(text) {
    var m = String(text || '').match(/(\d+)\s*(?:-|–|—|to)\s*(\d+)\s*(business\s*days?|days?|weeks?)/i);
    if (!m) return null;
    var unit = /business/i.test(m[3]) ? 'bd' : (/week/i.test(m[3]) ? 'w' : 'd');
    return { min: parseInt(m[1], 10), max: parseInt(m[2], 10), unit: unit };
  }
  function shipRange(s) {
    var fmt = function (d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); };
    var plus = function (n) {
      var d = new Date();
      if (s.unit === 'bd') { var left = n; while (left > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) left--; } }
      else d.setDate(d.getDate() + n * (s.unit === 'w' ? 7 : 1));
      return d;
    };
    return fmt(plus(s.min)) + ' – ' + fmt(plus(s.max));
  }
  function runShip(el) {
    if (!el) return;
    var root = el.closest('[data-product]');
    var desc = root && $('[data-desc]', root);
    var s = parseShip(el.dataset.shipsIn) || parseShip(desc ? desc.textContent : '') || {
      min: parseInt(el.dataset.defaultMin, 10) || 3,
      max: parseInt(el.dataset.defaultMax, 10) || 5,
      unit: el.dataset.defaultUnit || 'bd'
    };
    var v = $('.ship-v', el);
    clearTimeout(el._t);
    el.classList.add('loading');
    v.innerHTML = '<span class="dots">Checking</span>';
    el._t = setTimeout(function () { el.classList.remove('loading'); v.textContent = shipRange(s); }, reduced() ? 0 : 1200);
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = $('[data-product-form]', root);
    var select = $('[data-variant-select]', root);
    var atc = $('[data-atc]', root);
    var err = $('[data-form-error]', root);
    var groups = $$('[data-option]', root);
    var sticky = document.querySelector('[data-sticky="' + root.dataset.section + '"]');
    var stickyBtn = sticky && $('[data-sticky-btn]', sticky);
    var chosen = groups.map(function (g) { var a = $('.size.active', g); return a ? a.dataset.value : null; });
    var single = groups.length === 0;
    var variant = null;

    function find() {
      if (single) return data.variants[0];
      if (chosen.some(function (v) { return v === null; })) return null;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < chosen.length; j++) if (v.options[j] !== chosen[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function availability() {
      groups.forEach(function (g, oi) {
        $$('.size', g).forEach(function (b) {
          var val = b.dataset.value;
          var ok = data.variants.some(function (v) {
            if (!v.available || v.options[oi] !== val) return false;
            for (var j = 0; j < chosen.length; j++) if (j !== oi && chosen[j] !== null && v.options[j] !== chosen[j]) return false;
            return true;
          });
          b.classList.toggle('unavail', !ok);
        });
      });
    }
    function update(pushUrl) {
      variant = find();
      availability();
      groups.forEach(function (g, i) {
        var label = $('[data-option-label="' + i + '"]', root);
        var name = g.dataset.optionName || 'size';
        if (label) label.textContent = chosen[i] !== null ? name + ': ' + chosen[i] : 'Select ' + name.toLowerCase();
      });
      if (variant) {
        document.dispatchEvent(new CustomEvent('ht:variant', { detail: { id: variant.id } }));
        select.value = variant.id;
        $('[data-price-now]', root).innerHTML = formatMoney(variant.price);
        var was = $('[data-price-was]', root);
        if (variant.compare_at_price > variant.price) { was.innerHTML = formatMoney(variant.compare_at_price); was.hidden = false; } else { was.hidden = true; }
        if (sticky) $('[data-sticky-price]', sticky).innerHTML = formatMoney(variant.price);
        if (variant.available) {
          atc.disabled = false; atc.innerHTML = 'Add to cart &mdash; ' + formatMoney(variant.price);
          if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = 'Add to cart'; }
        } else {
          atc.disabled = true; atc.textContent = 'Sold out';
          if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Sold out'; }
        }
        if (variant.featured_media && variant.featured_media.preview_image) showImage(variant.featured_media.preview_image.src, variant.featured_media.id);
        if (pushUrl && window.history && history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', variant.id); history.replaceState({}, '', u.toString());
        }
      } else if (data.available) {
        atc.disabled = false; atc.textContent = 'Select a ' + ((groups[0] && groups[0].dataset.optionName) || 'size').toLowerCase();
        if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = 'Select size'; }
      }
    }
    function showImage(src, id) {
      var img = $('.gallery-main img', root);
      if (!img || !src) return;
      img.removeAttribute('srcset'); img.src = sized(src, 1600);
      $$('.thumbs button', root).forEach(function (b) { b.classList.toggle('active', String(b.dataset.thumbId) === String(id)); });
    }
    function needSize() {
      var g = groups[0]; if (!g) return;
      g.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
      g.classList.remove('need'); void g.offsetWidth; g.classList.add('need');
      var label = $('[data-option-label="0"]', root);
      if (label) label.textContent = 'Select a ' + (g.dataset.optionName || 'size').toLowerCase();
    }
    function addCurrent(btn) {
      if (!variant) { needSize(); return; }
      if (!variant.available) return;
      err.hidden = true;
      var label = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding…';
      Cart.add(variant.id, 1).catch(function (e) { err.textContent = e.message; err.hidden = false; })
        .then(function () { btn.disabled = false; btn.innerHTML = label; });
    }

    groups.forEach(function (g, i) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.size'); if (!b) return;
        chosen[i] = b.dataset.value;
        $$('.size', g).forEach(function (x) { x.classList.toggle('active', x === b); });
        g.classList.remove('need');
        update(true);
      });
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); addCurrent(atc); });
    if (stickyBtn) stickyBtn.addEventListener('click', function () { if (variant) addCurrent(stickyBtn); else needSize(); });
    $$('[data-to-sizes]', root).forEach(function (b) { b.addEventListener('click', function () { if (variant) atc.scrollIntoView({ block: 'center', behavior: 'smooth' }); else needSize(); }); });
    $$('.thumbs button', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var img = $('.gallery-main img', root); if (!img) return;
        img.removeAttribute('srcset'); img.src = b.dataset.thumb;
        $$('.thumbs button', root).forEach(function (x) { x.classList.toggle('active', x === b); });
      });
    });
    var ship = $('[data-ship]', root);
    if (ship) { runShip(ship); ship.addEventListener('click', function () { runShip(ship); }); }

    if (sticky) {
      document.body.classList.add('has-sticky');
      if ('IntersectionObserver' in window) {
        if (root._io) root._io.disconnect();
        root._io = new IntersectionObserver(function (en) { sticky.classList.toggle('on', !en[0].isIntersecting); sticky.setAttribute('aria-hidden', en[0].isIntersecting ? 'true' : 'false'); });
        root._io.observe(atc);
      }
    }
    update(false);
  }

  /* ---------- complete-the-set bundle ---------- */
  function initBundle(el) {
    if (el._ready) return; el._ready = true;
    var items = $$('[data-bundle-item]', el);
    var btn = $('[data-bundle-add]', el), err = $('[data-bundle-error]', el);
    items.forEach(function (it) {
      it.addEventListener('click', function (e) {
        var c = e.target.closest('.chip'); if (!c || c.disabled) return;
        $$('.chip', it).forEach(function (x) { x.classList.toggle('active', x === c); });
        $('.bundle-sizes', it).classList.remove('need'); err.hidden = true;
      });
    });
    document.addEventListener('ht:variant', function (e) {
      var cur = $('[data-bundle-item][data-current]', el); if (!cur) return;
      var chip = $('.chip[data-variant="' + e.detail.id + '"]', cur);
      if (chip && !chip.disabled) $$('.chip', cur).forEach(function (x) { x.classList.toggle('active', x === chip); });
    });
    btn.addEventListener('click', function () {
      var picks = [], missing = null;
      items.forEach(function (it) {
        var a = $('.chip.active', it);
        if (a) picks.push({ id: parseInt(a.dataset.variant, 10), quantity: 1 });
        else if (!missing) missing = it;
      });
      if (missing) {
        var s = $('.bundle-sizes', missing); s.classList.remove('need'); void s.offsetWidth; s.classList.add('need');
        err.textContent = 'Pick a size for ' + missing.dataset.name; err.hidden = false;
        return;
      }
      var label = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding…';
      Cart.addItems(picks).catch(function (e2) { err.textContent = e2.message; err.hidden = false; })
        .then(function () { btn.disabled = false; btn.innerHTML = label; });
    });
  }

  /* ---------- lookbook slideshow ---------- */
  function initSlideshow(el) {
    var track = $('[data-track]', el);
    if (!track) return;
    var N = parseInt(el.dataset.count, 10) || 0;
    var speed = parseInt(el.dataset.speed, 10) || 4000;
    var autoplay = el.dataset.autoplay === 'true';
    var at = 0;
    clearInterval(el._t);
    function step() {
      var first = track.children[0]; if (!first) return 0;
      return first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
    }
    function place(animate) {
      track.classList.toggle('snap', !animate);
      track.style.transform = 'translateX(' + (-at * step()) + 'px)';
      if (!animate) void track.offsetWidth;
      $$('.slide-nav button', el).forEach(function (b, i) { b.classList.toggle('on', i === at % N); });
    }
    function go(n) {
      if (n < 0) { at = N; place(false); n = N - 1; }
      if (n > N) { at = at % N; place(false); n = at + 1; }
      at = n; place(true);
    }
    function play() {
      clearInterval(el._t);
      if (autoplay && N > 1 && !reduced()) el._t = setInterval(function () { go(at + 1); }, speed);
    }
    el._go = function (i) { at = at % N; go(i); play(); };
    track.addEventListener('transitionend', function () { if (at >= N) { at -= N; place(false); } });
    $$('.slide-nav button', el).forEach(function (b) { b.addEventListener('click', function () { el._go(parseInt(b.dataset.slide, 10)); }); });
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { go(at + (dx < 0 ? 1 : -1)); play(); }
    }, { passive: true });
    if (canHover()) {
      el.addEventListener('mouseenter', function () { clearInterval(el._t); });
      el.addEventListener('mouseleave', play);
    }
    window.addEventListener('resize', function () { place(false); });
    place(false);
    play();
  }

  /* ---------- modal ---------- */
  function openModal(id) {
    var tpl = document.getElementById(id), modal = $('#Modal');
    if (!tpl || !modal) return;
    $('#ModalTitle').textContent = tpl.dataset.title || '';
    var body = $('#ModalBody'); body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));
    modal.classList.add('on'); modal.setAttribute('aria-hidden', 'false');
  }
  function closeModal() {
    var modal = $('#Modal'); if (!modal) return;
    modal.classList.remove('on'); modal.setAttribute('aria-hidden', 'true');
  }

  /* ---------- global clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) { openMenu(); return; }
    if (t.closest('[data-menu-close]')) { closeMenu(); return; }
    if (t.closest('#MenuDrawer a')) { closeMenu(); return; }
    var cartOpen = t.closest('[data-cart-open]');
    if (cartOpen && HT.cartType !== 'page') { e.preventDefault(); Cart.open(); Cart.fetch(); return; }
    if (t.closest('[data-cart-close]')) { Cart.close(); return; }
    var q = t.closest('[data-qty]');
    if (q) { Cart.change(q.dataset.qty, Math.max(0, parseInt(q.dataset.to, 10))); return; }
    var plus = t.closest('[data-card-plus]');
    if (plus) {
      var card = plus.closest('.card'); var open = !card.classList.contains('open');
      $$('.card.open').forEach(function (c) { if (c !== card) { c.classList.remove('open'); var b = $('[data-card-plus]', c); if (b) { b.textContent = '+'; b.setAttribute('aria-expanded', 'false'); } } });
      card.classList.toggle('open', open); plus.textContent = open ? '×' : '+'; plus.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var qaOpen = t.closest('[data-qa-open]');
    if (qaOpen) { qaOpen.closest('.qa').classList.add('open'); return; }
    var addBtn = t.closest('[data-add]');
    if (addBtn && !addBtn.disabled) {
      addBtn.disabled = true;
      Cart.add(parseInt(addBtn.dataset.add, 10), 1).catch(function (er) { window.alert(er.message); }).then(function () {
        addBtn.disabled = false;
        var c = addBtn.closest('.card');
        if (c) { c.classList.remove('open'); var b = $('[data-card-plus]', c); if (b) { b.textContent = '+'; b.setAttribute('aria-expanded', 'false'); } }
      });
      return;
    }
    var m = t.closest('[data-modal-open]');
    if (m) { openModal(m.dataset.modalOpen); return; }
    if (t.closest('[data-modal-close]') || t.id === 'Modal') { closeModal(); return; }
    var recover = t.closest('[data-recover-open]');
    if (recover) { var r = $('[data-recover]'); if (r) { e.preventDefault(); r.style.display = 'block'; r.scrollIntoView({ behavior: 'smooth' }); } }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMenu(); Cart.close(); closeModal(); }
  });

  /* ---------- address forms: preselect saved country ---------- */
  function initAddressForms(scope) {
    $$('select[data-default]', scope).forEach(function (s) { if (s.dataset.default) s.value = s.dataset.default; });
  }

  /* ---------- boot ---------- */
  function initScope(scope) {
    initAnnouncement(scope);
    $$('[data-slideshow]', scope).forEach(initSlideshow);
    $$('[data-bundle]', scope).forEach(initBundle);
    $$('[data-product]', scope).forEach(initProduct);
    initAddressForms(scope);
  }
  function boot() {
    Cart.init();
    initScope(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initScope(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('[data-rotator],[data-slideshow]', e.target).forEach(function (el) { clearInterval(el._t); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var show = e.target.closest('[data-slideshow]');
    if (show && show._go) {
      var slides = $$('.slide', show).slice(0, parseInt(show.dataset.count, 10));
      var i = slides.indexOf(e.target);
      if (i > -1) { show._go(i); clearInterval(show._t); }
    }
    var ann = e.target.closest('[data-rotator]');
    if (ann) {
      clearInterval(ann._t);
      $$('.ann-msg', ann).forEach(function (m) { m.classList.toggle('on', m === e.target); });
    }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var ann = e.target.closest('[data-rotator]');
    if (ann) initAnnouncement(ann.parentNode);
  });

  window.HTCart = Cart;
})();
